import { UiSuspensefulOutlet } from '@experiences/ui-common';
import type { PropsWithChildren } from 'react';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { EmailSettings } from '../../common/constants/RouteNames';
import { routePaths } from '../../common/constants/routePaths';
import BreadcrumbProvider from '../../common/providers/BreadcrumbProvider';
import type { UiRouteObject } from '../../container/routeConfigs/UiRouteObject';

const OrganizationEmailSettingsRevampComponent = React.lazy(() =>
    import('../organizationsettings/email/OrganizationEmailSettingsRevampComponent'));

const HostMailSettingsProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { formatMessage: translate } = useIntl();

    const breadCrumbLinks = useMemo(() => [
        {
            index: 0,
            link: routePaths.admin,
            name: translate({ id: 'CLIENT_HOST' }),
        },
        {
            index: 1,
            link: routePaths.adminHostMailSettings,
            name: translate({ id: 'CLIENT_MAIL_SETTINGS' }),
        },
    ], [ translate ]);

    return <BreadcrumbProvider breadcrumbs={breadCrumbLinks}>
        {children}
    </BreadcrumbProvider>;
};

export const HostMailSettingsRoutes: UiRouteObject = {
    path: routePaths.adminHostMailSettings,
    element: <HostMailSettingsProvider>
        <UiSuspensefulOutlet />
    </HostMailSettingsProvider>,
    children: [
        {
            index: true,
            redirectUrls: [ EmailSettings ],
            element: <OrganizationEmailSettingsRevampComponent />,
        },
    ],
};
